import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrintCTASection() {
    const navigate = useNavigate();
    return (
        <section className="bg-print-cta">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[64px] md:py-[88px] text-center">
                <div className="max-w-[640px] mx-auto">

                    {/* Icon */}
                    <div className="w-[56px] h-[56px] rounded-[16px] bg-[#ff5323] flex items-center justify-center mx-auto mb-[24px]">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-[28px] h-[28px] text-white"
                        >
                            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                            <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                            <rect x="6" y="14" width="12" height="8" rx="1" />
                        </svg>
                    </div>

                    {/* Heading */}
                    <h2 className="font-semibold text-[28px] md:text-[40px] text-white tracking-[-0.5px] mb-[16px] leading-[1.15]">
                        Ready to change how you print?
                    </h2>

                    {/* Description */}
                    <p className="font-medium text-[16px] md:text-[18px] text-white leading-[1.6] mb-[36px]">
                        Whether you're sending a thesis to print, sourcing paper and toner from a local supplier, or looking for a local T-Shirt printer - SignetPrint is the marketplace that connects the entire print industry.
                    </p>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row gap-[12px] justify-center">

                        <button
                            onClick={() => navigate("/marketplace")}
                            className="inline-flex items-center justify-center gap-[8px] px-[32px] py-[15px] rounded-[12px] bg-white text-[#ff5323] font-semibold text-[16px] border border-transparent hover:bg-white/10 hover:border-white/15 hover:text-white transition-colors duration-200 no-underline shadow-[0px_4px_20px_rgba(255,83,35,0.4)] hover:shadow-none"
                        >
                            Browse Marketplace
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[18px] h-[18px]"
                            >
                                <path d="M5 12h14" />
                                <path d="m12 5 7 7-7 7" />
                            </svg>
                        </button>

                        <button
                            onClick={() => navigate("/onboarding/plan")}
                            className="inline-flex items-center justify-center gap-[8px] px-[32px] py-[15px] rounded-[12px] bg-white/10 text-white font-semibold text-[16px] hover:bg-white/20 transition-colors no-underline border border-white/15"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[18px] h-[18px]"
                            >
                                <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
                                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
                                <path d="M2 7h20" />
                                <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" />
                            </svg>
                            List Your Business
                        </button>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default PrintCTASection;
